import * as React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';

import { Error, Label } from './stylings';

interface IOwnProps {
    label?: string;
    name: string;
    required?: boolean;
}

type IProps = IOwnProps & UseFieldConfig<boolean>;

function Checkbox({ name, label, required, ...props }: IProps): JSX.Element {
    const { input, meta: { touched, error } } = useField(name, { ...props, type: 'checkbox' }) as any;
    return <div>
        <Label $error={error && touched}>
            <input {...input} type='checkbox' />{' '}
            {label}{required ? '*' : ''}
        </Label>
        {touched && error && <Error>{error}</Error>}
    </div>;
}

export default Checkbox;
